export default "__VITE_ASSET__069c96c0__"